import { ReviewGapsByPriorityStepCtrl } from './review-gaps.controller';

export const ReviewGapsByPriorityStepComponent = {
  controller: ReviewGapsByPriorityStepCtrl,
  bindings: {
    prevStep: '&',
    nextStep: '&',
  },
  template: require('./review-gaps.html'),
};
